export const SELECT_PIE_DE_PAGINA = [
    {
        value: 27,
        label: 'INPUT LABEL',
    },
    {
        value: 28,
        label: 'INPUT LINEA VACIA',
    },
    {
        value: 33,
        label: 'FIRMA',
    },
];

export const LIST_PIE_DE_PAGINA = {
    INPUT_LABEL: 27,
    INPUT_LINEA_VACIA: 28,
    FIRMA: 33,
};